import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { BUSINESS } from "../lib/business";

export default function CTASection({ title, subtitle }) {
  return (
    <section data-testid="cta-section" className="section-y">
      <div className="container-x">
        <div className="relative overflow-hidden rounded-3xl bg-primary text-white px-6 py-12 sm:px-12 sm:py-16 grain">
          <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-accent/20 blur-3xl" />
          <div className="relative max-w-2xl">
            <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-balance">
              {title || "Ready to get started?"}
            </h2>
            <p className="mt-3 text-white/80 leading-relaxed">
              {subtitle || "Send a few photos of your project and get a fast, honest estimate. No commitment required."}
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <Link to="/contact" data-testid="cta-request-estimate-btn" className="btn-gold">
                Request Free Estimate <ArrowRight size={18} />
              </Link>
              <a href={BUSINESS.phoneHref} data-testid="cta-call-now-btn" className="btn-outline-light">
                <Phone size={18} /> Call or Text: {BUSINESS.phone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
